import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { z } from "zod";
import { suspenseOptions } from "@/lib/suspense-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { getGetBatchQueryOptions } from "@/requests/gen/react-query/batch";
import BatchCreateForm from "../-form";
import { BatchCrumbs } from "../-crumbs";
import numericId from "@/lib/numeric-id";

const searchSchema = z.object({
  warehouseId: z.number().optional(),
});

export const Route = createFileRoute(
  "/_private/_warehouse-360/batch/$batchId/edit",
)({
  validateSearch: searchSchema,
  loader: ({ context: { queryClient }, params: { batchId } }) =>
    queryClient.ensureQueryData(getGetBatchQueryOptions(numericId(batchId))),
  component: BatchEditPage,
});

function BatchEditPage() {
  const { batchId } = Route.useParams();
  const { data: batch } = useSuspenseQuery(
    suspenseOptions(getGetBatchQueryOptions(numericId(batchId))),
  );

  return (
    <div>
      <title>Edit Batch - Legrande Health Portal</title>
      <BatchCrumbs />

      <Card>
        <CardHeader>
          <CardTitle>Edit Batch</CardTitle>
        </CardHeader>
        <CardContent>{batch && <BatchCreateForm batch={batch} />}</CardContent>
      </Card>
    </div>
  );
}
